import useDimensions from 'react-use-dimensions'

export { useDimensions }

export default useDimensions
